// Exports: OVERDUE_COLOR, COMPLETED_DURATION_COLOR, UPCOMING_DURATION_COLOR, EARLY_COMPLETE_COLOR, mapDurationTextClass, mapBackground, renderTextForDue, renderSubtaskTextForDue, renderDays, renderSubtaskDays
import {
  isSubtaskCompleted,
  isTaskCompleted,
} from "utils/tasks/taskHelpers";

export const OVERDUE_COLOR = "#ffdbdb";
export const COMPLETED_DURATION_COLOR = "#e5e0ff";
export const UPCOMING_DURATION_COLOR = "#fcffbb";
export const EARLY_COMPLETE_COLOR = "#c1ffe5";

const MS_IN_DAY = 1000 * 60 * 60 * 24;

const toDate = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const getDurationDates = (item) => {
  const now = new Date();
  const startDate = toDate(item?.start_date);
  const endDate = toDate(item?.end_date);
  const completedDate =
    toDate(item?.completed_on) || endDate || now;

  return { now, startDate, endDate, completedDate };
};

const renderDateWindow = (startDate, endDate) => {
  if (!startDate || !endDate) return "";

  return `${startDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })} - ${endDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })}`;
};

const isCompletedItem = (item) =>
  isTaskCompleted(item) || isSubtaskCompleted(item);

export const mapDurationTextClass = (item) => {
  const { now, endDate } = getDurationDates(item);
  if (!endDate) return "text-yellow-800";

  if (isCompletedItem(item)) {
    return endDate > now ? "text-green-800" : "text-purple-800";
  }

  const diffMs = now.getTime() - endDate.getTime();
  if (endDate > now || (diffMs > 0 && diffMs < MS_IN_DAY)) {
    return "text-yellow-800";
  }

  return "text-red-800";
};

export const mapBackground = (item) => {
  const { now, endDate } = getDurationDates(item);
  if (!endDate) return UPCOMING_DURATION_COLOR;

  if (isCompletedItem(item)) {
    return endDate > now ? EARLY_COMPLETE_COLOR : COMPLETED_DURATION_COLOR;
  }

  const diffMs = now.getTime() - endDate.getTime();
  if (endDate > now || (diffMs > 0 && diffMs < MS_IN_DAY)) {
    return UPCOMING_DURATION_COLOR;
  }

  return OVERDUE_COLOR;
};

const renderDueText = (item, completedCheck) => {
  const { now, startDate, endDate, completedDate } = getDurationDates(item);
  if (!endDate) return "Complete in";

  if (completedCheck(item)) {
    if (endDate > now) return "Before";
    return renderDateWindow(startDate, completedDate);
  }

  if (endDate > now) return "Complete in";

  const isOverdueByAtLeastOneDay =
    now.getTime() - endDate.getTime() >= MS_IN_DAY;

  return isOverdueByAtLeastOneDay ? "Overdue By" : "Complete in";
};

const renderDurationDays = (item, completedCheck) => {
  const { now, startDate, endDate, completedDate } = getDurationDates(item);

  if (!startDate || !endDate) return 0;

  const nowTime = now.getTime();
  const startTime = startDate.getTime();
  const endTime = endDate.getTime();
  const completedTime = completedDate.getTime();

  if (completedCheck(item)) {
    if (endTime > nowTime) {
      const days = (endTime - nowTime) / MS_IN_DAY;
      return days < 1 ? 0 : Math.ceil(days);
    }

    const days = (completedTime - startTime) / MS_IN_DAY;
    return days < 1 ? 0 : Math.ceil(days);
  }

  if (endTime < nowTime) {
    const days = (nowTime - endTime) / MS_IN_DAY;
    return days < 1 ? 0 : Math.ceil(days);
  }

  const days = (endTime - nowTime) / MS_IN_DAY;
  return days < 1 ? 0 : Math.ceil(days);
};

export const renderTextForDue = (task) =>
  renderDueText(task, isTaskCompleted);

export const renderSubtaskTextForDue = (subtask) =>
  renderDueText(subtask, isSubtaskCompleted);

export const renderDays = (task) =>
  renderDurationDays(task, isTaskCompleted);

export const renderSubtaskDays = (subtask) =>
  renderDurationDays(subtask, isSubtaskCompleted);
